import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Pos } from 'src/app/core/classes/pos';
import {
  FormGroup,
  Validators,
  FormBuilder,
  ControlContainer,
} from '@angular/forms';
import { FormControl } from '@angular/forms';
import { PreferredCallTime } from 'src/app/core/classes/preferredCallTime';
import { PosType } from 'src/app/core/classes/posType';

@Component({
  selector: 'dq-pos-general-data',
  templateUrl: './pos-general-data.component.html',
  styleUrls: ['./pos-general-data.component.scss'],
})
export class PosGeneralDataComponent implements OnInit, OnChanges {
  @Input()
  editMode: boolean = false;
  @Input()
  posSelected!: Pos;
  @Input()
  generalDataForm: FormGroup;

  @Input()
  preferredsCallTime: PreferredCallTime[] = [];

  @Input()
  posTypes: PosType[] = [];

  numberOfPhones: any = 1;
  numberOfMails: any = 1;

  statusDecode: Map<string, string> = new Map<string, string>();

  constructor(
    public controlContainer: ControlContainer,
    private formBuilder: FormBuilder
  ) {
    this.generalDataForm = this.formBuilder.group({});
    this.statusDecode.set('A', 'status.a');
    this.statusDecode.set('C', 'status.c');
    this.statusDecode.set('', 'status.');
    this.statusDecode.set('NULL', 'status.NULL');
  }

  getStatusCode(status?: string) {
    let value: any = '';
    if (status != undefined) {
      value = this.statusDecode.get(status);
    }
    return value;
  }

  ngOnInit(): void {
    this.initNumbers();
  }
  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    this.initNumbers();
  }

  initNumbers(): void {
    if (this.generalDataForm != null) {
      if (
        this.generalDataForm.get('phone2') != null &&
        this.generalDataForm.get('phone2')?.value
      ) {
        this.numberOfPhones = 2;
      }
      if (
        this.generalDataForm.get('phone3') != null &&
        this.generalDataForm.get('phone3')?.value
      ) {
        this.numberOfPhones = 3;
      }
      if (
        this.generalDataForm.get('email2') != null &&
        this.generalDataForm.get('email2')?.value
      ) {
        this.numberOfMails = 2;
      }
      if (
        this.generalDataForm.get('email3') != null &&
        this.generalDataForm.get('email3')?.value
      ) {
        this.numberOfMails = 3;
      }
    }
  }

  addMail() {
    if (this.numberOfMails < 3) {
      this.numberOfMails += 1;
      this.generalDataForm.get('email' + this.numberOfMails)?.setValue('');
    }
  }

  removeMail() {
    if (this.numberOfMails > 1) {
      this.generalDataForm.get('email' + this.numberOfMails)?.setValue('');
      this.numberOfMails -= 1;
    }
  }

  addPhone() {
    if (this.numberOfPhones < 3) {
      this.numberOfPhones += 1;
      this.generalDataForm.get('phone' + this.numberOfPhones)?.setValue('');
    }
  }

  removePhone() {
    if (this.numberOfPhones > 1) {
      this.generalDataForm.get('phone' + this.numberOfPhones)?.setValue('');
      this.numberOfPhones -= 1;
    }
  }

  changePreferredCallTime(item: any) {
    this.generalDataForm.get('preferredTimeCall')?.setValue(item.target.value);
  }

  changeTypePos(item: any) {
    this.generalDataForm.get('typePos')?.setValue(item.target.value);
  }
}
